import { Grid, Stack } from '@mui/material';
import React from 'react';
import { ViewportMode } from '../../hooks/useViewportMode';

export interface ResponsiveCollectionProps<T> {
    items: T[];
    getKey: (item: T) => React.Key;
    renderCard: (item: T) => React.ReactNode;
    desktop: React.ReactNode;
    viewMode: ViewportMode;
    emptyState?: React.ReactNode;
    ariaLabel?: string;
}

/**
 * Switches a collection between touch-oriented cards and its existing desktop
 * representation. Tablet keeps the card interaction model but uses two columns.
 */
const ResponsiveCollection = <T,>({
    items,
    getKey,
    renderCard,
    desktop,
    viewMode,
    emptyState = null,
    ariaLabel,
}: ResponsiveCollectionProps<T>) => {
    if (viewMode === 'desktop')
        return <>{desktop}</>;

    if (items.length === 0)
        return <>{emptyState}</>;

    if (viewMode === 'tablet') {
        return (
            <Grid container component="section" spacing={2} aria-label={ariaLabel} sx={{ p: 2 }}>
                {items.map(item => (
                    <Grid item xs={12} sm={6} key={getKey(item)}>
                        {renderCard(item)}
                    </Grid>
                ))}
            </Grid>
        );
    }

    return (
        <Stack component="section" spacing={1.5} aria-label={ariaLabel} sx={{ p: 1.5 }}>
            {items.map(item => <React.Fragment key={getKey(item)}>{renderCard(item)}</React.Fragment>)}
        </Stack>
    );
};

export default ResponsiveCollection;
